import React from 'react';

const carList = [
  // Small / Sedan Cars
  {
    images: ['/images/fleets/aura.jpg'],
    brand: 'Hyundai',
    available: true,
    location: 'Mumbai',
    title: 'Hyundai Aura',
    rating: 4.7,
    reviews: 180,
    price: 11,
    desc: 'Reliable and efficient Hyundai Aura, perfect for city rides with Omshree Cab.',
  },
  {
    images: ['/images/fleets/dsire.jpg'],
    brand: 'Maruti',
    available: true,
    location: 'Mumbai',
    title: 'Maruti Suzuki Dzire',
    rating: 4.8,
    reviews: 210,
    price: 12,
    desc: 'Affordable and spacious Maruti Suzuki Dzire, perfect for daily commutes.',
  },
  {
    images: ['/images/fleets/etios.jpg'],
    brand: 'Toyota',
    available: true,
    location: 'Mumbai',
    title: 'Toyota Etios',
    rating: 4.6,
    reviews: 150,
    price: 13,
    desc: 'Reliable Toyota Etios offering smooth rides across the city and beyond.',
  },

  // MUV / Mid-size Family Cars
  {
    images: ['/images/fleets/ertiga.jpg'],
    brand: 'Maruti',
    available: true,
    location: 'Mumbai',
    title: 'Maruti Suzuki Ertiga',
    rating: 4.8,
    reviews: 185,
    price: 15,
    desc: 'Comfortable Maruti Suzuki Ertiga for family trips and group travels.',
  },
  {
    images: ['/images/fleets/kia.jpg'],
    brand: 'Kia',
    available: true,
    location: 'Mumbai',
    title: 'Kia Carens',
    rating: 4.8,
    reviews: 170,
    price: 16,
    desc: 'Kia Carens offers a spacious and smooth ride, ideal for city and outstation trips.',
  },
  {
    images: ['/images/fleets/innova.jpg'],
    brand: 'Toyota',
    available: true,
    location: 'Mumbai',
    title: 'Toyota Innova',
    rating: 4.9,
    reviews: 200,
    price: 17,
    desc: 'Spacious Toyota Innova, perfect for family and group travel with Omshree Cab.',
  },
  {
    images: ['/images/fleets/innova-crysta.jpg'],
    brand: 'Toyota',
    available: true,
    location: 'Mumbai',
    title: 'Toyota Innova Crysta',
    rating: 5.0,
    reviews: 250,
    price: 18,
    desc: 'Luxury and comfort combined in Toyota Innova Crysta for your premium travel needs.',
  },

  // Premium / Luxury Car
  {
    images: ['/images/fleets/audi.jpg'],
    brand: 'Audi',
    available: true,
    location: 'Mumbai',
    title: 'Audi Luxury Car',
    rating: 5.0,
    reviews: 250,
    price: 60,
    desc: 'Experience luxury and comfort with Audi Luxury Car from Omshree Cab.',
  },

  // Large Vehicles
  {
    images: ['/images/fleets/tempo-trevellar.jpg'],
    brand: 'Tempo Traveller',
    available: true,
    location: 'Mumbai',
    title: 'Tempo Traveller',
    rating: 4.9,
    reviews: 110,
    price: 25,
    desc: 'Tempo Traveller for group tours and long-distance travel with Omshree Cab.',
  },
  {
    images: ['/images/fleets/mini-bus.jpg'],
    brand: 'Mini Bus',
    available: true,
    location: 'Mumbai',
    title: 'Mini Bus',
    rating: 4.8,
    reviews: 130,
    price: 35,
    desc: 'Mini Bus for group travel, ensuring comfort and safety on every journey.',
  },
  {
    images: ['/images/fleets/bus.jpg'],
    brand: 'Luxury Bus',
    available: true,
    location: 'Mumbai',
    title: 'Luxury Bus',
    rating: 4.9,
    reviews: 120,
    price: 50,
    desc: 'Travel comfortably in our Luxury Bus, ideal for large groups and long journeys.',
  },
];

const Ourfleets = () => {
  return (
<>


   <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Our Fleets</h2>
          </div>
        </div>
      </div>
    </div>

    <section className="car-section">
      <div className="container">
        <div className="row">
          {carList.map((car, idx) => (
            <div key={idx} className="col-lg-4 col-md-6">
              <div className="listing-item listing-item-two borderr">
                <div className="listing-img">
                  {/* Image slider simulation */}
                  {car.images.length > 1 ? (
                    <div className="img-slider">
                      {car.images.map((img, i) => (
                        <div key={i} className="slide-images">
                          <a href="listing-details.html">
                            <img src={img} className="img-fluid" alt={car.brand} />
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <a href="listing-details.html">
                      <img src={car.images[0]} className="img-fluid" alt={car.brand} />
                    </a>
                  )}

                  <div className="fav-item">
                    <div className="d-flex align-items-center gap-2">
                      <span className="featured-text">{car.brand}</span>
                      <span className="availability">{car.available ? 'Available' : 'Unavailable'}</span>
                    </div>
                    <a href="javascript:void(0)" className="fav-icon selected">
                      <i className="feather-heart"></i>
                    </a>
                  </div>

                  <span className="location text-center">
                    <i className="bx bx-map me-1"></i>
                    {car.location}
                  </span>
                </div>

                <div className="listing-content text-center">
                  <div className="listing-features d-flex align-items-center justify-content-between text-center">
                    <div className="list-rating">
                      <h3 className="listing-title">
                        <a href="/" className='text-center'>{car.title}</a>
                      </h3>
                    
                    </div>
                   
                  </div>

                  <div className="listing-details-group">
                    <p>{car.desc}</p>
                   
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default Ourfleets;